import {furnishingSize,type Furnishing} from './room-furnishings';
/** Delta is measured in room inches. Wall and wall-normal coordinate stay locked. */
export function dragPainting(item:Furnishing,delta:{x:number;y:number;z:number},ceiling:number):Furnishing{
 const size=furnishingSize(item),clamp=(n:number,min:number,max:number)=>Math.max(min,Math.min(max,n));
 const along=item.wall==='left'?'z':'x';
 return {...item,[along]:clamp(item[along]+delta[along],size.width/2,240-size.width/2),bottom:clamp(item.bottom+delta.y,0,Math.max(0,ceiling-size.height))};
}
